import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_playback",
  "use": "icon-icon_general_playback-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_playback\">\n<g>\n\t<rect x=\"13.5\" y=\"36\" width=\"21\" height=\"2\" />\n\t<path d=\"M8.5,11v22h31V11H8.5z M20.5,28.5v-13L30.8999996,22L20.5,28.5z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol